import { render, staticRenderFns } from "./LabelDetail.vue?vue&type=template&id=b192df94&scoped=true&"
import script from "./LabelDetail.vue?vue&type=script&lang=js&"
export * from "./LabelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b192df94",
  null
  
)

export default component.exports